import { convertToBoolean } from "../applications/SearchInventoryTool/new.helper";

const createSpecsShown = (mlp = {}) => {
	const specsShown = [];
	if (mlp.msrpLabel) {
		specsShown.push({
			key: "msrp",
			name: mlp.msrpLabel,
		});
	}
	if (mlp.mpgLabel) {
		specsShown.push({
			key: "mpg",
			name: mlp.mpgLabel,
		});
	}
	if (mlp.mpge) {
		specsShown.push({
			key: "mpge",
			name: mlp.mpge,
		});
	}
	if (mlp.range) {
		specsShown.push({
			key: "range",
			name: mlp.range,
		});
	}
	if (mlp.justMpge) {
		specsShown.push({
			key: "justMpge",
			name: mlp.justMpge,
		});
	}
	if (mlp.justMpg) {
		specsShown.push({
			key: "justMpg",
			name: mlp.justMpg,
		});
	}
	return specsShown;
};

const transformFilters = (filters = []) => {
	return filters.reduce((acc, filter) => {
		const outFilterSection = filter.property === "dealerDistance";
		const displayHeading = !(filter.property === "dealerDistance");
		return {
			...acc,
			[filter.property]: {
				...filter,
				expanded: convertToBoolean(filter.expanded),
				transformUpperCase: convertToBoolean(filter.transformUpperCase),
				outFilterSection: outFilterSection,
				displayHeading: displayHeading,
				truncatedElements: convertToBoolean(filter.seeMoreEnabled),
			},
		};
	}, {});
};

const createMsrpLinks = (vehicleCardData = {}) => {
	const msrpLinks = [];
	if (vehicleCardData?.estimatePaymentLabel?.text) {
		msrpLinks.push({
			handler: "estimatePayments",
			text: vehicleCardData?.estimatePaymentLabel?.text,
			href: vehicleCardData?.estimatePaymentLabel?.href,
			isActive: vehicleCardData?.estimatePaymentLabel?.isActive,
		});
	}
	if (vehicleCardData?.seeOffersLabel?.text) {
		msrpLinks.push({
			handler: "offers",
			text: vehicleCardData?.seeOffersLabel?.text,
			href: vehicleCardData?.seeOffersLabel?.href,
			isActive: vehicleCardData?.seeOffersLabel?.isActive,
		});
	}
	return msrpLinks;
};

const transformContactFormData = (formData = {}) => {
	const formFields =
		formData.fields?.reduce((acc, field) => {
			return {
				...acc,
				[field.id]: {
					type: "TextInput",
					name: field.id,
					label: field.label,
					errorMessage: field.errorMessage,
					validation: field.id,
					required: field.required,
				},
			};
		}, {}) || {};
	return {
		...formData,
		services: ["SLP"],
		fields: formFields,
		optionalText: "OPTIONAL", // Should be false for Toyota
		apis: {
			campaignCode: formData.campaignCode,
		},
		confirmationHeadline: formData.thankYouPage?.heading,
		confirmationSubline: formData.thankYouPage?.subHeading,
		serverErrorMessaging: {
			errorHeader: formData.serviceDownMessage?.heading,
			errorDescription: formData.serviceDownMessage?.text,
		},
		backToBrowseCta: {
			text: "CLOSE",
			theme: "PrimaryBlack",
			type: "button",
		},
	};
};

const messageMapping = {
	"hi-homepage": "sit-outside-region-41",
	"pr-homepage": "sit-outside-region-40",
	// The following should have new IDs created for and the mapping updated
	"dealers-invalid-zip": "sit-invalid-zip",
	"dealers-service-down": "sit-server-error",
};

const defaultErrorMessages = {
	"sit-server-error": {
		heading: "We’re currently unable to retrieve results.",
		id: "sit-server-error",
		text: "Thank you for your patience. Please check back soon.",
	},
	"sit-invalid-zip": {
		heading:
			"Unfortunately, we were unable to find vehicles that match your selection within 500 miles.",
		id: "sit-invalid-zip",
		text: "<span>Please try searching within a different <a onClick={onBackClick}>zip code</a> to continue.</span>",
	},
	"sit-compare-vehicle-error": {
		cta: {
			target: "_blank",
			text: "Close",
			theme: "PrimaryBlack",
		},
		heading: "This Feature Is Currently Unavailable",
		id: "sit-compare-vehicle-error",
		text: "Please try again later. We apologize for the inconvenience.",
	},
	"sit-invalid-vin": {
		heading:
			"This vehicle is no longer available. Contact dealer to find similar vehicles you may like.",
		id: "sit-invalid-vine",
		text: "<span>Please try searching within a different <a onClick={onBackClick}>zip code</a> to continue.</span>",
	},
};

const transformServiceMessages = (serviceMessages = []) =>
	serviceMessages.reduce((acc, message) => {
		return {
			...acc,
			...defaultErrorMessages,
			[messageMapping[message.id] || message.id]: message,
		};
	}, {});

const transformPriceDetailsModalHeader = (header = "", dapHeader = "") => {
	return `{isDap ? '${dapHeader || "Price Details"}' : '${header || "Total MSRP Details"}'}`;
};

export default (props = {}) => {
	const useHashRouter = window.editorMode || window.authoringMode;
	return {
		// TODO: Move to config.analytics in syndication to pull from page props when exposed
		section: "inventory",
		endpoint: props.endpoint,
		theme: props.theme,
		baseUrl: useHashRouter ? "/" : props.baseUrl,
		useHashRouter,
		noResultsMessage: props.noResultsMessage,
		serviceMessagesByID: transformServiceMessages(props.serviceMessages),
		fifmbanner: {
			id: props.fifmbanner?.id,
			theme: props.theme,
			heading: props.fifmbanner?.heading,
			subheading: props.fifmbanner?.subheading,
			bannerCTA: props.fifmbanner?.bannerCTA,
			media: props.fifmbanner?.media,
			showBanner: props.fifmbanner?.showBanner,
		},
		fifmTile: {
			...props.fifmtile,
			subHeading: props.fifmtile?.subheading,
		},

		priceDetailOverlayHeader: props.priceDetailOverlayHeader,
		priceDetailOverlayHeaderDap: props.priceDetailOverlayHeaderDap,

		priceDetailsBreakdownHeading: props.priceDetailsBreakdownHeading,
		priceDetailsBreakdownHeadingDap: props.priceDetailsBreakdownHeadingDap,

		priceDetailsModalFooter: props.priceDetailsModalFooter,
		priceDetailsModalBaseCopy: props.priceDetailsModalBaseCopy,
		priceDetailsModalCTA: props.priceDetailsModalCTA,

		globalTotalMsrpDisclaimer: props.globalTotalMsrpDisclaimer,
		globalDapDisclaimer: props.globalDapDisclaimer,
		globalMSRPLabel: props.globalMSRPLabel,

		priceDetailsModalBaseDisclaimer: props.priceDetailsModalBaseDisclaimer,
		dphCopy: props.dphCopy,

		ZipGateData: {
			hasPin: props.zipGate?.hasPin === "true",
			pinName: "PinAlternate",
			topHeading: props.zipGate?.heading,
			zipEntryPosition: props.zipGate?.zipEntryPosition,
			theme: props.zipGate?.theme,
			zipEntry: {
				...props.zipGate?.zipEntry,
				heading: props.zipGate?.description,
				hint: props.zipGate?.inputPlaceholder,
				hasPin: false,
				submitCTA: {
					text: props.zipGate?.submitLabel,
					size: "toyota",
					theme: "ToyotaRed",
				},
			},
			optionalCTAs: [props.zipGate?.optionalCTAs],
			iconColor: props.zipGate?.iconColor || "#e10a1d",
			media: props.zipGate?.media,
			errorCopy:
				"To search inventory in another region, modify your ZIP Code below.",
		},
		ModelGridData: {
			theme: props.theme,
			header: props.mlp?.heading,
			specsShown: createSpecsShown(props.mlp),
			disclaimer: props.mlp?.disclaimer,
			ghostJellyImage: props.mlp?.ghostJellyImage,
		},
		VehicleGridData: {
			theme: props.theme,
			variation: "VLP",
			header: props.vlp?.heading,
			backLink: props.vlp?.backButtonText.text,
			msrpLinks: createMsrpLinks(props.vlp?.vehicleCards),
			unlockPricingLabel: props.vlp?.unlockPricingLabel || "Unlock Savings",
			detailsCTA: props.vlp?.vehicleCards?.viewDetails,
			contactCTA: props.vlp?.vehicleCards?.contactCTA,
			contactMonogramCTA: props.vlp?.contactMonogramCTA || {
				text: "PAYMENT OPTIONS",
				href: false,
				theme: "PrimaryBlack",
				type: "button",
				breakpoints: [],
			},
			presoldBadgeCopy: props.vlp?.presoldBadgeCopy,
			unlockPricingPath:
				props.vlp?.unlockPricingPath ||
				"https://smartpath.toyota.com/inventory/details",
			filterCtaLabel: props.vlp?.filterCtaLabel,
			expandCopyBlock: props.vlp?.expandCopyBlock,
			expandLabel: props.vlp?.expandLabel,
			collapseLabel: props.vlp?.collapseLabel,
			similarExpandLabel: props.vlp?.similarExpandLabel,
			similarCollapseLabel: props.vlp?.similarCollapseLabel,
			smartPathDescription: props.vlp?.smartPathDescription,
			tileMsrpHeadingLabel: props.vlp?.tileMsrpHeadingLabel,
			enableDG: props.vlp?.enableDG,
			exactMatchLabel: props.vlp?.exactMatchLabel || "Exact Matches",
			similarMatchLabel: props.vlp?.similarMatchLabel || "Similar Matches",
			tileMatchLabel: props.vlp?.tileMatchLabel,
			// Mileage Disclaimer
			mileageDisclaimer:
				props.vlp?.mileageDisclaimer ||
				"Accumulated miles as reported by the dealer. Reported mileage may increase if vehicle is driven at a later date, please contact dealer to confirm.",
		},
		CompareVehicleData: {
			enableCV: props.compare?.enableCV,
			title: props.compare?.title,
			backButton: props.compare?.backButton,
			detailsCTA: props.compare?.detailsCTA,
			contactCTA: props.compare?.contactCTA,
			labelCompareVehicle: props.compare?.toggleCompareLabel,
			trayLabel: props.compare?.trayLabel,
			trayCTA: props.compare?.trayCTA,
			limitModalCopy: props.compare?.limitModalCopy,
			limitModalSubCopy: props.compare?.limitModalSubcopy,
			limitModalCTA: props.compare?.limitModalCTA,
		},
		PreviouslyViewedData: {
			title: props.pv?.title,
			subTitle: props.pv?.subTitle,
			contactCTA: props.pv?.contactCTA,
		},
		VehicleDetailsData: {
			...props.vdp,
			exteriorLabel: "Exterior",
			interiorLabel: "Interior",
			galleryDisclaimer: props.vdp?.galleryImageDisclaimer,
			overlayHeader: props.vdp?.details?.heading,
			openModalCTA: props.vdp?.viewAllVehicleDetailsCta,
			backLabel: props.vdp?.backButtonText?.text,
			detailsTabs: props.vdp?.details?.featureTabs,
			windowStickerLabel: props.vdp?.windowStickerCta?.text,
			dealerContactCTA: props.vdp?.dealerContactCta,
			dealerSiteCTA: props.vdp?.dealerSiteCta,
			paymentEstimatorEndpoint:
				props.vdp?.paymentEstimatorEndpoint ||
				"https://www.sit.pes.tms.aws.toyota.com/",
			contactFormData: transformContactFormData(props?.formData),
			priceDetailOverlayHeader: transformPriceDetailsModalHeader(
				props.priceDetailOverlayHeader,
				props.priceDetailOverlayHeaderDap,
			),
			offerTerms: props.vdp?.offers,
			sfe: {
				enableSFE: props.sfe?.enableSFE,
				heading: props.sfe?.heading,
				subheading: props.sfe?.subheading,
			},
			contactCTA: props?.vdp?.contactCTA,
			contactMonogramCTA: props?.vdp?.contactMonogramCTA || {
				text: "PAYMENT OPTIONS",
				href: false,
				theme: "PrimaryBlack",
				type: "button",
				breakpoints: [],
			},
			startMonogramCTA: props?.vdp?.startMonogramCTA || {
				text: "START NOW",
				href: false,
				theme: "PrimaryWhite",
				type: "button",
				breakpoints: [],
			},
			smartPathDescription: props.vlp?.smartPathDescription,
			monogramLabel:
				props?.vdp?.monogramLabel ||
				"The fast, convenient and hassle-free shopping process that puts you in control. Get instant trade-in estimates, browse payment options, apply for financing, and more.",
			msrpLegalText: props.vdp?.msrpLegalText,
		},
		offersObject: {
			globalOfferTypes: props.offers?.globalOfferTypes,
			sortByYear: props.offers?.sortByYear,
		},
		vehicleFilters: transformFilters(props.vlp?.filters),
		modelFilters: {
			category: {
				heading: "Vehicle Type",
				type: "checkbox",
			},
			msrp: {
				heading: "Price",
				type: "range",
			},
		},
		disclosureDisclaimer: props.vlp?.disclaimer,
	};
};
